let appliedFilters = [];
let appliedSort = '';
let sectionID = document.getElementById("product-grid").dataset.id;
let bundlesSectionID = "template--16153969754290__product-grid";
let initialProductCount = parseInt(document.getElementById("productQuantity").innerText);

const userDiv = document.querySelector(".collection-mobile");
let userOnMobile = userDiv.getBoundingClientRect().width > 0;

window.addEventListener("resize", () => {
    if (window.innerWidth >= 770) {
        userOnMobile = false;
    } else {
        userOnMobile = true;
    }
});

// sort functionality
function handleSort() {
    document.addEventListener("click", (event) => {
        if (!document.getElementById("customSelect").contains(event.target) && event.target.id !== "sortBy") {
            document.getElementById("customSelect").classList.add("hidden");
        }
    });
    document.getElementById("sortBy").onclick = () => document.getElementById("customSelect").classList.toggle("hidden");

    sorter();
}

// filter functionality
let bundleAssigned = false;

function handleFilter() {
    let index = 0;
    document.querySelectorAll(".filterType").forEach((e, i) => {
        e.addEventListener("click", async () => {
            e.closest(".filterWrapper").classList.toggle("displayFilter");

            const { filtertype } = e.dataset;
            if (filtertype !== undefined && filtertype === "bundles") {
                document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.remove("hidden"));
                if (!bundleAssigned) {
                    updateFiltersList("clear");
                    const bundleHTML = await dataHandler(true);

                    if (bundleHTML) {
                        document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.add("hidden"));
                        document.getElementById("product-grid").innerHTML = bundleHTML;
                        bundleAssigned = true;

                        if (userOnMobile) {
                            closeFilterModal();

                            document.querySelector(".collection-clear-btn").onclick = async () => {
                                updateFiltersList("clear");
                                appliedFilters = [];
                                appliedSort = '';

                                document.querySelectorAll(".filterSelect").forEach(e => e.classList.remove("filterSelected"));
                                document.getElementById("sortedBy").innerText = `(Low to High)`;

                                document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.remove("hidden"));
                                const defaultData = await dataHandler();

                                if (defaultData) {
                                    document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.add("hidden"));
                                    setData(defaultData);

                                    closeFilterModal();
                                }
                            }
                        }
                    }
                } else {
                    updateFiltersList("clear");
                    const defaultData = await dataHandler();

                    if (defaultData) {
                        document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.add("hidden"));
                        setData(defaultData);
                        bundleAssigned = false;
                    }
                }
            }
        });
    });

    filterer();

    document.getElementById("clearFilters").addEventListener("click", async () => {
        updateFiltersList("clear");
        appliedFilters = [];
        appliedSort = '';

        document.querySelectorAll(".filterSelect").forEach(e => e.classList.remove("filterSelected"));
        document.getElementById("sortedBy").innerText = `(Low to High)`;

        document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.remove("hidden"));
        const defaultData = await dataHandler();

        if (defaultData) {
            document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.add("hidden"));
            setData(defaultData);
        }
    });

    document.getElementById("mdDisplayFilter").onclick = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
        });
        document.getElementById("gorgias-chat-container").style.display = "none";

        document.querySelector(".filtersWrapper").classList.remove("hidden");
        setTimeout(() => {
            document.querySelector(".filtersWrapper").style.bottom = "0px";
            document.querySelector(".filtersWrapper").classList.add("mdActiveFilter");
            document.querySelector(".popupDark").classList.add("active");
            document.body.style.overflow = "hidden";

            enableMobileFilterHide(document.querySelector(".filtersWrapper-CloserTab"));

            [document.querySelector(".popupDark"), document.getElementById("filterTitleHide")].forEach(e => {
                e.onclick = () => {
                    closeFilterModal();
                }
            });
        }, 100);
    }
}

// sort options functionality
function sorter() {
    document.querySelectorAll(".customOption").forEach((e, i, arr) => {
        e.addEventListener("click", async () => {
            arr.forEach(x => x.classList.remove("selected"));
            e.classList.add("selected");

            const { value } = e.dataset;
            appliedSort = value;
            // set sort identifier
            document.getElementById("sortedBy").innerText = `(${e.innerText})`;

            try {
                document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.remove("hidden"));

                if (bundleAssigned) {
                    const bundleHTML = await dataHandler(true);

                    if (bundleHTML) {
                        document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.add("hidden"));
                        document.getElementById("product-grid").innerHTML = bundleHTML;
                        bundleAssigned = true;
                    }
                } else {
                    const sortedData = await dataHandler();
                    if (sortedData) {
                        document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.add("hidden"));
                        setData(sortedData);
                    }
                }
            } catch (err) { // handle error
            }
        });
    });
}

function filterer() {
    document.querySelectorAll(".filterSelect").forEach(e => {
        e.addEventListener("click", async () => {
            bundleAssigned = false;
            e.classList.toggle("filterSelected");

            let includes = false;
            appliedFilters.forEach(tag => {
                if (tag[0] === e.dataset.value) {
                    includes = true;
                };
            });

            if (includes) {
                appliedFilters = appliedFilters.filter(i => i[0] !== e.dataset.value);
            } else {
                appliedFilters.push([e.dataset.value, e.innerText]);
            }

            try {
                if (!userOnMobile) {
                    document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.remove("hidden"));

                    const filteredData = await dataHandler();
                    if (filteredData) {
                        document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.add("hidden"));
                        updateFiltersList(appliedFilters);
                        setData(filteredData);
                    }
                } else {
                    document.querySelector(".collection-apply-btn").onclick = async () => {
                        document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.remove("hidden"));

                        const filteredData = await dataHandler();
                        if (filteredData) {
                            document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.add("hidden"));
                            updateFiltersList(appliedFilters);
                            setData(filteredData);

                            closeFilterModal();
                        }
                        document.querySelectorAll(".appliedFilter").forEach(e => e.setAttribute("disabled", false));
                    }
                    document.querySelector(".collection-clear-btn").onclick = async () => {
                        updateFiltersList("clear");
                        appliedFilters = [];
                        appliedSort = '';

                        document.querySelectorAll(".filterSelect").forEach(e => e.classList.remove("filterSelected"));
                        document.getElementById("sortedBy").innerText = `(Low to High)`;

                        document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.remove("hidden"));
                        const defaultData = await dataHandler();

                        if (defaultData) {
                            document.querySelectorAll(".custom-loading-overlay").forEach(e => e.classList.add("hidden"));
                            setData(defaultData);

                            closeFilterModal();
                        }
                    }
                }
            } catch (err) { // handle err
            }
        });
    });
}


window.addEventListener("DOMContentLoaded", () => {
    handleSort();
    handleFilter();
});


// utilities
async function dataHandler(bundles = false) {
    let query = '';
    let requestURL;

    if (bundles) {
        if (appliedSort) {
            requestURL = `/collections/new-bundles?sort_by=${appliedSort}`;
        } else requestURL = "/collections/new-bundles";

        const response = await fetch(requestURL)
        .then((res) => res.text())
        .then((data) => {
            const domContent = new DOMParser().parseFromString(data, "text/html");
            const bundleContent = domContent.getElementById("ProductGridContainer").querySelector("#product-grid");

            const liQuantity = bundleContent.querySelectorAll("li.li-xmwrwf").length;
            document.getElementById("productQuantity").innerText = liQuantity;

            return bundleContent.innerHTML;
        });
        return response;
    } else {
        if (appliedFilters.length > 0) {
            appliedFilters.forEach((tag, i, arr) => {
                if (i !== arr.length - 1) {
                    query += `${tag[0]}+`;
                } else {
                    query += `${tag[0]}`;
                }
            });
        }
        if (query !== "" && appliedSort !== "") {
            requestURL = `${window.location.pathname}/${query}?sort_by=${appliedSort}&sections=${sectionID}`;
        } else if (appliedSort && query === "") {
            requestURL = `${window.location.pathname}?sort_by=${appliedSort}&sections=${sectionID}`;
        } else if (appliedSort === "" && query !== "") {
            requestURL = `${window.location.pathname}/${query}?sections=${sectionID}`;
        } else {
            requestURL = `${window.location.pathname}?sections=${sectionID}`;
        }

        const request = await fetch(requestURL);
        const response = await request.json();

        let data = await response;
        bundles ? data = data[bundlesSectionID] : data = data[sectionID];

        return data;
    }
}

function updateFiltersList(value) {
    if (value === "clear") {
        appliedFilters = [];
        document.getElementById("selectedTags").innerHTML = '';
        document.querySelectorAll(".filterSelect").forEach(e => e.classList.remove("filterSelected"));
    } else {
        document.getElementById("selectedTags").innerHTML = '';
        value.forEach(tag => {
            let value = tag[0];
            let text = tag[1];

            const constructedFilter = document.createElement("span");
            constructedFilter.className = "appliedFilter";
            constructedFilter.innerText = text;
            constructedFilter.setAttribute("data-value", value);

            document.getElementById("selectedTags").appendChild(constructedFilter);
        });
    }

    const filtersLength = document.getElementById("selectedTags").querySelectorAll("span").length;
    if (filtersLength > 0 && window.innerWidth > 990) {
        document.getElementById("clearFilters").classList.remove("hidden");
    } else {
        document.getElementById("clearFilters").classList.add("hidden");
    }

    document.querySelectorAll(".appliedFilter").forEach((e, i, arr) => {
        e.addEventListener("click", () => {
            if (e.getAttribute("disabled") === "false") {
                let filterSelects = document.querySelectorAll(".filterSelect");
                filterSelects = [...filterSelects].find(filter => filter.dataset.value === e.dataset.value);
                filterSelects.click();
                arr.forEach(e => e.setAttribute("disabled", true));

                if (userOnMobile) {
                    document.querySelector(".collection-apply-btn").click();
                }
            }
        });
    });
}

function setData(data) {
    const temp = document.createElement("div");
    temp.innerHTML = data;

    const sortedData = temp.querySelector("#product-grid-wrapper") || temp.querySelector(".collection.page-width").querySelector("#product-grid");
    let productsQuantity = 0;
    try {
        if (sortedData.id === "product-grid") {
            sortedData.querySelectorAll("li.li-vrxfjh").forEach(e => e.classList.add("md:w-[300px]"));
            productsQuantity = sortedData.querySelectorAll("li.li-vrxfjh").length;

            document.getElementById("product-grid").innerHTML = sortedData.innerHTML;
        } else {
            productsQuantity = sortedData.querySelector("#product-grid").querySelectorAll("li.li-vrxfjh").length;
            document.getElementById("product-grid-wrapper").innerHTML = sortedData.innerHTML;
        }
        document.getElementById("productQuantity").innerText = productsQuantity;
    } catch(e) {
        if (e) {
            document.getElementById("productQuantity").innerText = 0;
            const notFoundTemplate = document.querySelector("template#collectionsnf");

            document.getElementById("product-grid-wrapper").innerHTML = '';
            document.getElementById("product-grid-wrapper").append(notFoundTemplate.content.cloneNode(true));
        }
    }

    initializeProductCards();
}

let filterBottomValue = parseInt(getComputedStyle(document.querySelector(".filtersWrapper")).bottom);

function enableMobileFilterHide(node) {
    let startingY = 0, hideable = false, rect = node.getBoundingClientRect(), top = 0;

    node.addEventListener("touchstart", (event) => {
        startingY = event.changedTouches[0].clientY;
        top = rect.top;
    });

    node.addEventListener("touchmove", (event) => {
        event.preventDefault();

        const ableToMove = ((startingY - top) <= 30);
        if (ableToMove) {
            hideable = true;

            const clientY = event.changedTouches[0].clientY;
            const diffY = clientY - startingY;
            const newBottom = filterBottomValue - diffY;

            node.style.bottom = `${newBottom}px`;

            let currentBottom = node.style.bottom;
            if (parseInt(currentBottom) > 0) {
                node.style.bottom = `${filterBottomValue}px`;
                return;
            }
            if (parseInt(currentBottom) < -150) {
                hideable = false;
                closeFilterModal();
                return;
            }
        }
    });

    node.addEventListener("touchend", () => {
        if (hideable) {
            node.style.bottom = `${filterBottomValue}px`;
        }
    });
}

function closeFilterModal() {
    document.querySelectorAll(".filterWrapper").forEach(e => e.classList.remove("displayFilter"));
    const modal = document.querySelector(".filtersWrapper.mdActiveFilter");
    modal.style.bottom = "-480px";

    setTimeout(() => {
        document.getElementById("gorgias-chat-container").style.display = "block";

        document.querySelector(".popupDark").classList.remove("active");
        modal.style.bottom = "-480px";

        document.body.style.overflow = "auto";
        modal.classList.add("hidden");
    }, 300);
}
